import React from 'react';
import {
  Box,
  IconButton,
  Typography,
  Select,
  MenuItem,
  FormControl
} from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon
} from '@mui/icons-material';

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  itemsPerPageOptions = [10, 25, 50, 100]
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  // Always show pagination, even for single page

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-end',
      gap: 2,
      p: 2,
      borderTop: '1px solid #e2e8f0',
      background: '#ffffff'
    }}>
      {/* Rows per page selector */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
          Rows per page:
        </Typography>
        <FormControl size="small" sx={{ minWidth: 60 }}>
          <Select
            value={itemsPerPage}
            onChange={(e) => onItemsPerPageChange(parseInt(e.target.value))}
            sx={{
              '& .MuiSelect-select': {
                py: 0.5,
                fontSize: '0.875rem'
              }
            }}
          >
            {itemsPerPageOptions.map((option) => (
              <MenuItem key={option} value={option} sx={{ fontSize: '0.875rem' }}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* Item count */}
      <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
        {startItem}-{endItem} of {totalItems}
      </Typography>

      {/* Navigation arrows */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <IconButton
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          size="small"
          sx={{
            color: currentPage === 1 ? 'text.disabled' : 'text.primary',
            '&:hover': {
              bgcolor: currentPage === 1 ? 'transparent' : 'action.hover'
            }
          }}
        >
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        
        <IconButton
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          size="small"
          sx={{
            color: currentPage === totalPages ? 'text.disabled' : 'text.primary',
            '&:hover': {
              bgcolor: currentPage === totalPages ? 'transparent' : 'action.hover'
            }
          }}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Pagination;
